import { GRID_STRING_COL_DEF } from '@mui/x-data-grid';
import { Grid2, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { WebsiteCell } from '../Shared/TableCells/WebsiteCell.js';
import { LogoUploader } from './LogoUploader.js';
import { getPlatform, useScreenOrientation } from '../../utilities/orientationAndPlatform.js';


export function ChannelPageTableValueCell({...params}){

    const sizeStatus = params.sizeStatus
    var iconSize = 0;
    if (sizeStatus === 'compact') iconSize = '2rem' 
    else if (sizeStatus === 'standard') iconSize = '4rem'
    else if (sizeStatus === 'comfortable') iconSize = '6rem'

    let rightPadding = ''
    let platform = getPlatform()
    let orientation = useScreenOrientation()
    if (platform === 'mobile' && orientation === 0) rightPadding = '25%'
    

    //onClick function that implements click-to-copy
    function clickToCopy(cellValue){
        navigator.clipboard.writeText(cellValue)
    }

    const row = params.row
    const cellType = row.id
    const cellValue = row.fieldValue

    //boolean cells
    if (cellValue === true){
        return (
            <Grid2 display={'flex'} justifyContent={'flex-end'} paddingRight={rightPadding}>
                <CheckIcon color='text' sx={{fontSize: iconSize}} onClick={() => clickToCopy(cellValue)}></CheckIcon>
            </Grid2>
        )
    }
    else if (cellValue === false){
        return (
            <Grid2 display={'flex'} justifyContent={'flex-end'} paddingRight={rightPadding}>
                <CloseIcon color='text' sx={{fontSize: iconSize}} onClick={() => clickToCopy(cellValue)}></CloseIcon>
            </Grid2>
        )
    }

    //website cell
    else if (cellType === 'Website'){
        return (
            <Grid2 display={'flex'} justifyContent={'flex-end'} paddingRight={rightPadding}>
                <WebsiteCell url={row.fieldValue}></WebsiteCell>
            </Grid2>
        )
    }

    else if (cellType === 'Contact'){
        return "";
    }

    //all other cells
    else if (cellType !== 'Station Logo'){
        let isNotANumber = isNaN(cellValue)

        //Load a tooltip on hover for cells that don't hold a number value
        if (isNotANumber === true){
            return (
                <>
                    <Grid2 display={'flex'} justifyContent={'flex-end'} paddingRight={rightPadding}>
                        <Tooltip title={cellValue} placement='bottom'>
                            <div onClick={() => clickToCopy(cellValue)}>{cellValue}</div>
                        </Tooltip>
                    </Grid2>
                </>
            )
        } else {
            return (
                <Grid2 display={'flex'} justifyContent={'flex-end'} paddingRight={rightPadding}>
                    <div onClick={() => clickToCopy(cellValue)}>{cellValue}</div>
                </Grid2>
            )
        }
    }

    //Station Logo cell case only
    let callSign = params.callSign
    let affiliate = params.affiliate
    return (
        <Grid2 display={'flex'} justifyContent={'flex-end'} paddingRight={rightPadding}>
            <LogoUploader callSign={callSign} affiliate={affiliate}></LogoUploader>
        </Grid2>
    )
}


export function ChannelPageTableValueCellType(){
    return {
        ...GRID_STRING_COL_DEF,
        type: 'custom',
        filterable: false,
        sortable: false,
        editable: false,
        groupable: false,
        renderCell: (params) => <ChannelPageTableValueCell {...params} />,
    };
}
